import { ReducerBuilder } from './reducerBuilder';
import { BrokerDetailsState } from '../store/brokerDetailsState';
import { AllBrokerDetailsRequest, BrokerDetailsForBookingRequest } from 'acscp/api/requests';
import { AllBrokerDetails, BrokerDetails } from 'acscp/api/models/brokerDetails';
import { ClearBrokerDetails } from 'acscp/actions';

export const brokerDetailsReducer =
    new ReducerBuilder<BrokerDetailsState>({})
        .successfulRequestCase(AllBrokerDetailsRequest, (state, brokerDetails: AllBrokerDetails) => ({
            broker: brokerDetails.primaryBroker || undefined,
        }))
        .successfulRequestCase(BrokerDetailsForBookingRequest, (state, brokerDetails: BrokerDetails) => ({
            broker: brokerDetails,
        }))
        .actionCase(ClearBrokerDetails, (state, action) => ({
            broker: undefined
        }))
        .build();
